/* crypto.randomUUID() requires a secure context — undefined on http://<lan-ip>,
   the phone-over-LAN dev setup. crypto.getRandomValues is available in ALL
   contexts (same CSPRNG), so the fallback is a real RFC-4122 v4 — the discard
   DTO validates idempotencyKey as UUID and would 400 on anything else. */
export const uuidV4Fallback = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"))
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10).join("")
  ].join("-")
}

export const generateUuid = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : uuidV4Fallback()
